export default __webpack_public_path__ + "static/1-e179a1cb20bd1b3a3e8baeed3f85daaa.png";